import { ifAuthenticated, mustBeAdmin } from "../util/auth";

const MultipleEmployee = () =>
  import("../components/content/employee/multipleEmployee");
const Onboardemployee = () =>
  import("../components/content/employee/onboardemployee");
const Birthdays = () => import("../components/content/employee/birthdays");
const Employee = () => import("../components/content/employee/employee");
const FormInput = () => import("../components/content/employee/FormInput");
const Batchupload = () => import("../components/content/employee/batchupload");
const ViewEmployee = () =>
  import("../components/content/employee/viewEmployee");

export const employeeRoutes = {
  path: "/employee",
  component: Employee,
  children: [
    {
      path: "",
      component: Batchupload
    },
    {
      path: "/onboardemployee",
      component: Onboardemployee
    },
    {
      path: "/birthdays",
      component: Birthdays
    },
    {
      path: "/multipleEmployee",
      component: MultipleEmployee
    },
    {
      path: "/formInput",
      component: FormInput
    },
    {
      path: "/employee/:id",
      name: "viewEmployee",
      component: ViewEmployee
    }
  ],
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
